<div class="center-align margin-top-20 margin-bottom-20" *ngIf="dataSource.data.length === 0 && networkCallInProgress">
    <mat-spinner [diameter]="35"></mat-spinner>
</div>
<div *ngIf="dataSource.data.length > 0" class="table-container {{isMobile?'':'responsive-table'}}">

    <mat-table [dataSource]="dataSource" matSort matSortActive="numberOfEmisOverdue" matSortDirection="desc"
        class="finzyfont margin-top-20" multiTemplateDataRows>
        <ng-container matColumnDef="portfolioName">
            <mat-header-cell *matHeaderCellDef>Portfolio Name</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <span>{{element.portfolioName}}<br>
                    <span class="small-text">
                        ({{ (element.createdAt | date: 'dd ') +
                        (element.createdAt | date: 'MMM ' | uppercase) +
                        (element.createdAt | date: 'yyyy')}})
                    </span>
                </span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="font-bold">Total</mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="loanId">
            <mat-header-cell *matHeaderCellDef style="padding-right: 25px"> Loan ID<br>(Rating)</mat-header-cell>
            <mat-cell *matCellDef="let element" style="padding-right: 25px"> <span>
                    <span>{{element.loanId}}</span> <br><span class="small-text">({{element.rating}})
                        ({{element.loan_tenure}} MONTH)</span>
                </span> </mat-cell>
            <mat-footer-cell *matFooterCellDef class="font-bold"></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="investmentInLoan">
            <mat-header-cell *matHeaderCellDef>Investment <br> in Loan</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <app-indian-currency-formatter [amount]="element.investmentInLoan">
                </app-indian-currency-formatter>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="font-bold">
                <app-indian-currency-formatter [amount]="totalInvestmentInLoan">
                </app-indian-currency-formatter>
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="grossCashFlowReceived">
            <mat-header-cell *matHeaderCellDef>Gross Cashflow<br />Received</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <app-indian-currency-formatter [amount]="element.grossCashFlowReceived">
                </app-indian-currency-formatter>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="font-bold">
                <app-indian-currency-formatter [amount]="totalGrossCashFlow">
                </app-indian-currency-formatter>
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="netInterestEarned">
            <mat-header-cell *matHeaderCellDef>Net Interest<br />Earned</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <app-indian-currency-formatter [amount]="element.netInterestEarned">
                </app-indian-currency-formatter>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="font-bold">
                <app-indian-currency-formatter [amount]="totalInterestEarned">
                </app-indian-currency-formatter>
            </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="outstandingPrincipal">
            <mat-header-cell *matHeaderCellDef>Outstanding<br />principal</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <app-indian-currency-formatter [amount]="element.outstandingPrincipal">
                </app-indian-currency-formatter>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="font-bold">
                <app-indian-currency-formatter [amount]="totalOutstandingPrincipal">
                </app-indian-currency-formatter>
            </mat-footer-cell>
        </ng-container>


        <!--
                                                <ng-container matColumnDef="numberOfDaysDelayed">
                                                    <mat-header-cell *matHeaderCellDef>No. of days delayed</mat-header-cell>
                                                    <mat-cell
                                                            *matCellDef="let element"> {{element.numberOfDaysDelayed}} </mat-cell>
                                                </ng-container>
        -->
        <ng-container matColumnDef="numberOfEmiReceived">
            <mat-header-cell *matHeaderCellDef>No. of EMIs<br /> Received</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.numberOfEmiReceived}} </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="numberOfEmisOverdue">
            <mat-header-cell *matHeaderCellDef mat-sort-header>No. of EMIs<br />overdue
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.numberOfEmisOverdue}}
                EMI(s)
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="totalAmountOverdue">
            <mat-header-cell *matHeaderCellDef>Net overdue <br /> EMI</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <app-indian-currency-formatter [amount]="element.totalNetAmountOverdue">
                </app-indian-currency-formatter>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="font-bold">
                <app-indian-currency-formatter [amount]="totalDelayedEmiAmount">
                </app-indian-currency-formatter>
            </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="lastPaymentDate">
            <mat-header-cell *matHeaderCellDef>Last Payment<br />Received</mat-header-cell>
            <mat-cell *matCellDef="let element" [ngStyle]="{color: element.lastPaymentDate | paymentDateTextColor}"> {{
                element.lastPaymentDate !== '-' ? (element.lastPaymentDate | date: 'dd ') + (element.lastPaymentDate |
                date: 'MMM ' | uppercase) + (element.lastPaymentDate | date: 'yy') : element.lastPaymentDate}}

            </mat-cell>

            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="accordion_arrow">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element" style="justify-content: flex-end;max-width: 46px;">
                <mat-icon style="font-family: 'Material Icons';font-size: 18px;">{{element == expandedElement ?
                    'arrow_drop_up' : 'arrow_drop_down'}}
                </mat-icon>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let element">
                <div class="accordion-element-detail" *ngIf="isMobile"
                    [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Gross Cashflow<br />Received
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                <app-indian-currency-formatter [amount]="element.grossCashFlowReceived">
                                </app-indian-currency-formatter>
                            </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%">
                            Net Interest<br />Earned
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>{{element.netInterestEarned}}</span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Outstanding<br />principal
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                <app-indian-currency-formatter [amount]="element.outstandingPrincipal">
                                </app-indian-currency-formatter>
                            </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            No. of EMIs<br /> Received
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>{{element.numberOfEmiReceived}} </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            No. of EMIs<br />overdue
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>{{element.numberOfEmisOverdue}}
                                EMI(s)</span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Net overdue <br /> EMI
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                <app-indian-currency-formatter [amount]="element.totalNetAmountOverdue">
                                </app-indian-currency-formatter>
                            </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Last Payment<br />Received
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span [ngStyle]="{color: element.lastPaymentDate | paymentDateTextColor}">{{
                                element.lastPaymentDate !== '-' ? (element.lastPaymentDate | date: 'dd ') +
                                (element.lastPaymentDate |
                                date: 'MMM ' | uppercase) + (element.lastPaymentDate | date: 'yy') :
                                element.lastPaymentDate}}</span>
                        </div>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns;" class="accordion-element-row"
            [class.accordion-expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element"></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="accordion-detail-row">
        </mat-row>

        <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
    </mat-table>

    <div class=" margin-bottom-20"></div>
</div>